// AskPanelSection.js — the Tier-3 combined-panel shell: the two-column grid
// (filters | 1px divider | results) with the panel title + subtext at the top
// of the LEFT column. Everything behavior-specific (AskConsole, the results
// body, the boundary labels) is passed in as children, so this file owns only
// the layout — the part that made LocalIntelligencePage hard to scan.
//
// Layout contract (unchanged from the inline version): the grid is the panel's
// only child inside CARD_PAD, so the divider (self-stretch + items-stretch)
// spans the FULL panel height top-to-bottom and the results header sits level
// with the title. Both columns always render so a need click fills the right
// column without reflowing the left one.
import React from 'react';
import { CARD_PAD, CARD_TITLE } from '../liStyles';
import InfoTip from '../../shared/InfoTip';

const AskPanelSection = ({ filters, results }) => (
  <section id="panel-ask" className={`${CARD_PAD} ring-1 ring-[#32B1FF]/30`} aria-label="What Does the Guest Need?">
    <div className="grid grid-cols-1 lg:grid-cols-[1fr_1px_1fr] gap-6 items-stretch">
      {/* Left column — panel title + subtext, then the filter controls */}
      <div className="min-w-0">
        <div>
          <h2 className={`${CARD_TITLE} text-lg`}>
            What Does the Guest Need?
            <InfoTip text="Tap what the guest wants, set who is going and when, and give them one of the top three. Every answer has the sentence to say and the button to act." />
          </h2>
          <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">Tap a need or type what the guest is after — we'll find the best places nearby.</p>
        </div>
        <div className="mt-4">{filters}</div>
      </div>

      {/* Divider — subtle 1px line using the app's muted border token; hidden on
          mobile where the two columns stack vertically. */}
      <div className="hidden lg:block w-px self-stretch bg-gray-200/50 dark:bg-gray-800/50" aria-hidden="true" />

      {/* Right column — results body (or empty state). Stretches to full panel
          height; the pagination footer pins to the bottom via mt-auto inside
          PageResultsBody. */}
      <div className="min-w-0 h-full min-h-0 flex flex-col [&>*]:flex-1 [&>*]:min-h-0">{results}</div>
    </div>
  </section>
);

export default AskPanelSection;
